export enum LIST_TYPE_MY_ASSET {
  HOLD = 'HOLD',
  FINISH = 'FINISH',
  HISTORY = 'HISTORY',
}

export enum LIST_TYPE_ARTFAIR {
  ART_MUSEUM = 'ART_MUSEUM',
  EVENT = 'EVENT',
}

export enum LIST_TYPE_NOTIFICATION {
  NOTICE = 'NOTICE',
  NOTIFICATION = 'NOTIFICATION',
  SELL = 'SELL',
}

export enum LIST_TYPE_MARKET {
  SALE = 'SALE',
  TRADE = 'TRADE',
  TRADE_STATUS = 'TRADE_STATUS',
}
